const ARTICLE_SPLIT_REGEX = /[,;\n\r]+/;

export const parseArticles = (raw: string): string[] =>
  raw
    .split(ARTICLE_SPLIT_REGEX)
    .map((item) => item.trim())
    .filter(Boolean);

type TArticleMatchable = { sku: string; external_id?: string | null };

export const articleMatchesProduct = (article: string, product: TArticleMatchable): boolean => {
  const normalized = article.toLowerCase();
  return product.sku.toLowerCase() === normalized || (product.external_id?.toLowerCase() ?? '') === normalized;
};

export const productMatchesAnyArticle = (product: TArticleMatchable, articles: string[]): boolean =>
  articles.some((article) => articleMatchesProduct(article, product));

export const mergeUniqueArticles = (current: string[], incoming: string[]): string[] => {
  const existing = new Set(current.map((item) => item.toLowerCase()));
  const next = [...current];

  incoming.forEach((article) => {
    const normalized = article.toLowerCase();
    if (!existing.has(normalized)) {
      existing.add(normalized);
      next.push(article);
    }
  });

  return next;
};
